export default "__VITE_ASSET__t38p5oXl__"